import { Modal } from '@/shared/components/Modal'

// First-login welcome shown once per user (gated on is_new_user + a localStorage
// flag in AuthGuard). Mirrors DemoJoinSuccessModal's body styling so the two
// welcome surfaces read consistently. Purely presentational - the caller owns
// the show-once / persistence logic and the "get started" navigation.
export function WelcomeModal({ onClose, onGetStarted }: { onClose: () => void; onGetStarted: () => void }) {
  return (
    <Modal track="welcome" title="Welcome to Terramantle" onClose={onClose}>
      <p className="guide-para">
        Here's what you can do:
      </p>
      <ul className="guide-list">
        <li>Modules - publish, browse and deprecate versioned Terraform modules</li>
        <li>State Files - inspect state and force-unlock stuck locks</li>
        <li>Providers - serve upstream and terramantle-built providers, retrieve SBOMs</li>
        <li>Dependency Graph - explore your module relationships</li>
      </ul>
      <div style={{ background: 'var(--accent-d)', border: '1px solid color-mix(in srgb, var(--accent-fill) 20%, transparent)', borderRadius: 6, padding: '10px 14px', fontFamily: 'var(--body)', fontSize: '0.8rem', color: 'var(--text2)', marginBottom: 14, lineHeight: 1.5 }}>
        Your input shapes what we build next - share it
        any time via <strong>Send feedback</strong> in the navigation menu.
      </div>
      <div className="modal-actions">
        <button className="btn btn-sm" onClick={onClose}>Dismiss</button>
        <button className="btn btn-primary btn-sm" onClick={onGetStarted}>Get started →</button>
      </div>
    </Modal>
  )
}
